module.exports = __webpack_public_path__ + "img/audience-pencil.7a014ce7.svg";